/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Badge,
  Button,
  Divider,
  Flex,
  Grid,
  Icon,
  ScrollView,
  SwitchField,
  Text,
  TextField,
  useTheme,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { createVideoContent } from "../graphql/mutations";
const client = generateClient();
function ArrayField({
  items = [],
  onChange,
  label,
  inputFieldRef,
  children,
  hasError,
  setFieldValue,
  currentFieldValue,
  defaultFieldValue,
  lengthLimit,
  getBadgeText,
  runValidationTasks,
  errorMessage,
}) {
  const labelElement = <Text>{label}</Text>;
  const {
    tokens: {
      components: {
        fieldmessages: { error: errorStyles },
      },
    },
  } = useTheme();
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState();
  const [isEditing, setIsEditing] = React.useState();
  React.useEffect(() => {
    if (isEditing) {
      inputFieldRef?.current?.focus();
    }
  }, [isEditing]);
  const removeItem = async (removeIndex) => {
    const newItems = items.filter((value, index) => index !== removeIndex);
    await onChange(newItems);
    setSelectedBadgeIndex(undefined);
  };
  const addItem = async () => {
    const { hasError } = runValidationTasks();
    if (
      currentFieldValue !== undefined &&
      currentFieldValue !== null &&
      currentFieldValue !== "" &&
      !hasError
    ) {
      const newItems = [...items];
      if (selectedBadgeIndex !== undefined) {
        newItems[selectedBadgeIndex] = currentFieldValue;
        setSelectedBadgeIndex(undefined);
      } else {
        newItems.push(currentFieldValue);
      }
      await onChange(newItems);
      setIsEditing(false);
    }
  };
  const arraySection = (
    <React.Fragment>
      {!!items?.length && (
        <ScrollView height="inherit" width="inherit" maxHeight={"7rem"}>
          {items.map((value, index) => {
            return (
              <Badge
                key={index}
                style={{
                  cursor: "pointer",
                  alignItems: "center",
                  marginRight: 3,
                  marginTop: 3,
                  backgroundColor:
                    index === selectedBadgeIndex ? "#B8CEF9" : "",
                }}
                onClick={() => {
                  setSelectedBadgeIndex(index);
                  setFieldValue(items[index]);
                  setIsEditing(true);
                }}
              >
                {getBadgeText ? getBadgeText(value) : value.toString()}
                <Icon
                  style={{
                    cursor: "pointer",
                    paddingLeft: 3,
                    width: 20,
                    height: 20,
                  }}
                  viewBox={{ width: 20, height: 20 }}
                  paths={[
                    {
                      d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
                      stroke: "black",
                    },
                  ]}
                  ariaLabel="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    removeItem(index);
                  }}
                />
              </Badge>
            );
          })}
        </ScrollView>
      )}
      <Divider orientation="horizontal" marginTop={5} />
    </React.Fragment>
  );
  if (lengthLimit !== undefined && items.length >= lengthLimit && !isEditing) {
    return (
      <React.Fragment>
        {labelElement}
        {arraySection}
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      {labelElement}
      {isEditing && children}
      {!isEditing ? (
        <>
          <Button
            onClick={() => {
              setIsEditing(true);
            }}
          >
            Add item
          </Button>
          {errorMessage && hasError && (
            <Text color={errorStyles.color} fontSize={errorStyles.fontSize}>
              {errorMessage}
            </Text>
          )}
        </>
      ) : (
        <Flex justifyContent="flex-end">
          {(currentFieldValue || isEditing) && (
            <Button
              children="Cancel"
              type="button"
              size="small"
              onClick={() => {
                setFieldValue(defaultFieldValue);
                setIsEditing(false);
                setSelectedBadgeIndex(undefined);
              }}
            ></Button>
          )}
          <Button size="small" variation="link" onClick={addItem}>
            {selectedBadgeIndex !== undefined ? "Save" : "Add"}
          </Button>
        </Flex>
      )}
      {arraySection}
    </React.Fragment>
  );
}
export default function VideoContentCreateForm(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    contentPath: "",
    poster: "",
    category: "",
    title: "",
    year: "",
    rated: "",
    released: "",
    runtime: "",
    genre: [],
    director: "",
    actors: "",
    plot: "",
    imdbRating: "",
    tomatoMeter: "",
    fileId: "",
    tomatoRating: "",
    onlyDeployMetaData: false,
    isActive: false,
  };
  const [contentPath, setContentPath] = React.useState(
    initialValues.contentPath
  );
  const [poster, setPoster] = React.useState(initialValues.poster);
  const [category, setCategory] = React.useState(initialValues.category);
  const [title, setTitle] = React.useState(initialValues.title);
  const [year, setYear] = React.useState(initialValues.year);
  const [rated, setRated] = React.useState(initialValues.rated);
  const [released, setReleased] = React.useState(initialValues.released);
  const [runtime, setRuntime] = React.useState(initialValues.runtime);
  const [genre, setGenre] = React.useState(initialValues.genre);
  const [director, setDirector] = React.useState(initialValues.director);
  const [actors, setActors] = React.useState(initialValues.actors);
  const [plot, setPlot] = React.useState(initialValues.plot);
  const [imdbRating, setImdbRating] = React.useState(initialValues.imdbRating);
  const [tomatoMeter, setTomatoMeter] = React.useState(
    initialValues.tomatoMeter
  );
  const [fileId, setFileId] = React.useState(initialValues.fileId);
  const [tomatoRating, setTomatoRating] = React.useState(
    initialValues.tomatoRating
  );
  const [onlyDeployMetaData, setOnlyDeployMetaData] = React.useState(
    initialValues.onlyDeployMetaData
  );
  const [isActive, setIsActive] = React.useState(initialValues.isActive);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setContentPath(initialValues.contentPath);
    setPoster(initialValues.poster);
    setCategory(initialValues.category);
    setTitle(initialValues.title);
    setYear(initialValues.year);
    setRated(initialValues.rated);
    setReleased(initialValues.released);
    setRuntime(initialValues.runtime);
    setGenre(initialValues.genre);
    setCurrentGenreValue("");
    setDirector(initialValues.director);
    setActors(initialValues.actors);
    setPlot(initialValues.plot);
    setImdbRating(initialValues.imdbRating);
    setTomatoMeter(initialValues.tomatoMeter);
    setFileId(initialValues.fileId);
    setTomatoRating(initialValues.tomatoRating);
    setOnlyDeployMetaData(initialValues.onlyDeployMetaData);
    setIsActive(initialValues.isActive);
    setErrors({});
  };
  const [currentGenreValue, setCurrentGenreValue] = React.useState("");
  const genreRef = React.createRef();
  const validations = {
    contentPath: [],
    poster: [],
    category: [],
    title: [],
    year: [],
    rated: [],
    released: [],
    runtime: [],
    genre: [],
    director: [],
    actors: [],
    plot: [],
    imdbRating: [],
    tomatoMeter: [],
    fileId: [],
    tomatoRating: [],
    onlyDeployMetaData: [],
    isActive: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          contentPath,
          poster,
          category,
          title,
          year,
          rated,
          released,
          runtime,
          genre,
          director,
          actors,
          plot,
          imdbRating,
          tomatoMeter,
          fileId,
          tomatoRating,
          onlyDeployMetaData,
          isActive,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: createVideoContent.replaceAll("__typename", ""),
            variables: {
              input: {
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "VideoContentCreateForm")}
      {...rest}
    >
      <TextField
        label="Content path"
        isRequired={false}
        isReadOnly={false}
        value={contentPath}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath: value,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.contentPath ?? value;
          }
          if (errors.contentPath?.hasError) {
            runValidationTasks("contentPath", value);
          }
          setContentPath(value);
        }}
        onBlur={() => runValidationTasks("contentPath", contentPath)}
        errorMessage={errors.contentPath?.errorMessage}
        hasError={errors.contentPath?.hasError}
        {...getOverrideProps(overrides, "contentPath")}
      ></TextField>
      <TextField
        label="Poster"
        isRequired={false}
        isReadOnly={false}
        value={poster}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster: value,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.poster ?? value;
          }
          if (errors.poster?.hasError) {
            runValidationTasks("poster", value);
          }
          setPoster(value);
        }}
        onBlur={() => runValidationTasks("poster", poster)}
        errorMessage={errors.poster?.errorMessage}
        hasError={errors.poster?.hasError}
        {...getOverrideProps(overrides, "poster")}
      ></TextField>
      <TextField
        label="Category"
        isRequired={false}
        isReadOnly={false}
        value={category}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category: value,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.category ?? value;
          }
          if (errors.category?.hasError) {
            runValidationTasks("category", value);
          }
          setCategory(value);
        }}
        onBlur={() => runValidationTasks("category", category)}
        errorMessage={errors.category?.errorMessage}
        hasError={errors.category?.hasError}
        {...getOverrideProps(overrides, "category")}
      ></TextField>
      <TextField
        label="Title"
        isRequired={false}
        isReadOnly={false}
        value={title}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title: value,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.title ?? value;
          }
          if (errors.title?.hasError) {
            runValidationTasks("title", value);
          }
          setTitle(value);
        }}
        onBlur={() => runValidationTasks("title", title)}
        errorMessage={errors.title?.errorMessage}
        hasError={errors.title?.hasError}
        {...getOverrideProps(overrides, "title")}
      ></TextField>
      <TextField
        label="Year"
        isRequired={false}
        isReadOnly={false}
        value={year}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year: value,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.year ?? value;
          }
          if (errors.year?.hasError) {
            runValidationTasks("year", value);
          }
          setYear(value);
        }}
        onBlur={() => runValidationTasks("year", year)}
        errorMessage={errors.year?.errorMessage}
        hasError={errors.year?.hasError}
        {...getOverrideProps(overrides, "year")}
      ></TextField>
      <TextField
        label="Rated"
        isRequired={false}
        isReadOnly={false}
        value={rated}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated: value,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.rated ?? value;
          }
          if (errors.rated?.hasError) {
            runValidationTasks("rated", value);
          }
          setRated(value);
        }}
        onBlur={() => runValidationTasks("rated", rated)}
        errorMessage={errors.rated?.errorMessage}
        hasError={errors.rated?.hasError}
        {...getOverrideProps(overrides, "rated")}
      ></TextField>
      <TextField
        label="Released"
        isRequired={false}
        isReadOnly={false}
        value={released}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released: value,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.released ?? value;
          }
          if (errors.released?.hasError) {
            runValidationTasks("released", value);
          }
          setReleased(value);
        }}
        onBlur={() => runValidationTasks("released", released)}
        errorMessage={errors.released?.errorMessage}
        hasError={errors.released?.hasError}
        {...getOverrideProps(overrides, "released")}
      ></TextField>
      <TextField
        label="Runtime"
        isRequired={false}
        isReadOnly={false}
        value={runtime}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime: value,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.runtime ?? value;
          }
          if (errors.runtime?.hasError) {
            runValidationTasks("runtime", value);
          }
          setRuntime(value);
        }}
        onBlur={() => runValidationTasks("runtime", runtime)}
        errorMessage={errors.runtime?.errorMessage}
        hasError={errors.runtime?.hasError}
        {...getOverrideProps(overrides, "runtime")}
      ></TextField>
      <ArrayField
        onChange={async (items) => {
          let values = items;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre: values,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            values = result?.genre ?? values;
          }
          setGenre(values);
          setCurrentGenreValue("");
        }}
        currentFieldValue={currentGenreValue}
        label={"Genre"}
        items={genre}
        hasError={errors?.genre?.hasError}
        runValidationTasks={async () =>
          await runValidationTasks("genre", currentGenreValue)
        }
        errorMessage={errors?.genre?.errorMessage}
        setFieldValue={setCurrentGenreValue}
        inputFieldRef={genreRef}
        defaultFieldValue={""}
      >
        <TextField
          label="Genre"
          isRequired={false}
          isReadOnly={false}
          value={currentGenreValue}
          onChange={(e) => {
            let { value } = e.target;
            if (errors.genre?.hasError) {
              runValidationTasks("genre", value);
            }
            setCurrentGenreValue(value);
          }}
          onBlur={() => runValidationTasks("genre", currentGenreValue)}
          errorMessage={errors.genre?.errorMessage}
          hasError={errors.genre?.hasError}
          ref={genreRef}
          labelHidden={true}
          {...getOverrideProps(overrides, "genre")}
        ></TextField>
      </ArrayField>
      <TextField
        label="Director"
        isRequired={false}
        isReadOnly={false}
        value={director}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director: value,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.director ?? value;
          }
          if (errors.director?.hasError) {
            runValidationTasks("director", value);
          }
          setDirector(value);
        }}
        onBlur={() => runValidationTasks("director", director)}
        errorMessage={errors.director?.errorMessage}
        hasError={errors.director?.hasError}
        {...getOverrideProps(overrides, "director")}
      ></TextField>
      <TextField
        label="Actors"
        isRequired={false}
        isReadOnly={false}
        value={actors}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors: value,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.actors ?? value;
          }
          if (errors.actors?.hasError) {
            runValidationTasks("actors", value);
          }
          setActors(value);
        }}
        onBlur={() => runValidationTasks("actors", actors)}
        errorMessage={errors.actors?.errorMessage}
        hasError={errors.actors?.hasError}
        {...getOverrideProps(overrides, "actors")}
      ></TextField>
      <TextField
        label="Plot"
        isRequired={false}
        isReadOnly={false}
        value={plot}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot: value,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.plot ?? value;
          }
          if (errors.plot?.hasError) {
            runValidationTasks("plot", value);
          }
          setPlot(value);
        }}
        onBlur={() => runValidationTasks("plot", plot)}
        errorMessage={errors.plot?.errorMessage}
        hasError={errors.plot?.hasError}
        {...getOverrideProps(overrides, "plot")}
      ></TextField>
      <TextField
        label="Imdb rating"
        isRequired={false}
        isReadOnly={false}
        value={imdbRating}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating: value,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.imdbRating ?? value;
          }
          if (errors.imdbRating?.hasError) {
            runValidationTasks("imdbRating", value);
          }
          setImdbRating(value);
        }}
        onBlur={() => runValidationTasks("imdbRating", imdbRating)}
        errorMessage={errors.imdbRating?.errorMessage}
        hasError={errors.imdbRating?.hasError}
        {...getOverrideProps(overrides, "imdbRating")}
      ></TextField>
      <TextField
        label="Tomato meter"
        isRequired={false}
        isReadOnly={false}
        value={tomatoMeter}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter: value,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.tomatoMeter ?? value;
          }
          if (errors.tomatoMeter?.hasError) {
            runValidationTasks("tomatoMeter", value);
          }
          setTomatoMeter(value);
        }}
        onBlur={() => runValidationTasks("tomatoMeter", tomatoMeter)}
        errorMessage={errors.tomatoMeter?.errorMessage}
        hasError={errors.tomatoMeter?.hasError}
        {...getOverrideProps(overrides, "tomatoMeter")}
      ></TextField>
      <TextField
        label="File id"
        isRequired={false}
        isReadOnly={false}
        value={fileId}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId: value,
              tomatoRating,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.fileId ?? value;
          }
          if (errors.fileId?.hasError) {
            runValidationTasks("fileId", value);
          }
          setFileId(value);
        }}
        onBlur={() => runValidationTasks("fileId", fileId)}
        errorMessage={errors.fileId?.errorMessage}
        hasError={errors.fileId?.hasError}
        {...getOverrideProps(overrides, "fileId")}
      ></TextField>
      <TextField
        label="Tomato rating"
        isRequired={false}
        isReadOnly={false}
        value={tomatoRating}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating: value,
              onlyDeployMetaData,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.tomatoRating ?? value;
          }
          if (errors.tomatoRating?.hasError) {
            runValidationTasks("tomatoRating", value);
          }
          setTomatoRating(value);
        }}
        onBlur={() => runValidationTasks("tomatoRating", tomatoRating)}
        errorMessage={errors.tomatoRating?.errorMessage}
        hasError={errors.tomatoRating?.hasError}
        {...getOverrideProps(overrides, "tomatoRating")}
      ></TextField>
      <SwitchField
        label="Only deploy meta data"
        defaultChecked={false}
        isDisabled={false}
        isChecked={onlyDeployMetaData}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData: value,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.onlyDeployMetaData ?? value;
          }
          if (errors.onlyDeployMetaData?.hasError) {
            runValidationTasks("onlyDeployMetaData", value);
          }
          setOnlyDeployMetaData(value);
        }}
        onBlur={() =>
          runValidationTasks("onlyDeployMetaData", onlyDeployMetaData)
        }
        errorMessage={errors.onlyDeployMetaData?.errorMessage}
        hasError={errors.onlyDeployMetaData?.hasError}
        {...getOverrideProps(overrides, "onlyDeployMetaData")}
      ></SwitchField>
      <SwitchField
        label="Is active"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isActive}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              contentPath,
              poster,
              category,
              title,
              year,
              rated,
              released,
              runtime,
              genre,
              director,
              actors,
              plot,
              imdbRating,
              tomatoMeter,
              fileId,
              tomatoRating,
              onlyDeployMetaData,
              isActive: value,
            };
            const result = onChange(modelFields);
            value = result?.isActive ?? value;
          }
          if (errors.isActive?.hasError) {
            runValidationTasks("isActive", value);
          }
          setIsActive(value);
        }}
        onBlur={() => runValidationTasks("isActive", isActive)}
        errorMessage={errors.isActive?.errorMessage}
        hasError={errors.isActive?.hasError}
        {...getOverrideProps(overrides, "isActive")}
      ></SwitchField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
